// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1987":"41a5a193","2047":"41a5a193","2947":"11b01132","4624":"fe052a2a","8775":"41a5a193","9805":"4d00b3b9"}[chunkId] + ".chunk.css";
};